import type { DropdownMenuItem } from '@nuxt/ui';
import type { ColumnHeaderActionGroup } from './Base.vue';

/**
 * Assembles the column header dropdown groups: consumer `headerActions` are anchored around the
 * built-in groups (`[sort, visibility]`), and empty groups are dropped so no stray dividers render.
 */
export function buildColumnHeaderItemGroups(
	headerActions: ColumnHeaderActionGroup[],
	builtinGroups: DropdownMenuItem[][],
): DropdownMenuItem[][] {
	const start = headerActions.filter((group) => (group.anchor ?? 'start') === 'start').map((group) => group.items);
	const end = headerActions.filter((group) => group.anchor === 'end').map((group) => group.items);

	return [...start, ...builtinGroups, ...end].filter((group) => group.length > 0);
}
